$(document).ready(function () {
  init.push(function () {
    // Javascript code here

    $('#bs-datepicker-component').datepicker();
  });
  console.log(window.PixelAdmin);
  window.PixelAdmin.start(init);
});
